const storageKey = 'tavus_conversation_data';

export const storage = {
  getStoredConversation() {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Failed to get stored conversation:', error);
      return null;
    }
  },

  storeConversation(data) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (error) {
      console.error('Failed to store conversation:', error);
    }
  },

  clearStoredConversation() {
    try {
      localStorage.removeItem(storageKey);
    } catch (error) {
      console.error('Failed to clear stored conversation:', error);
    }
  },

  getLastConversationEndTime() {
    try {
      const stored = localStorage.getItem('govava_last_chat_end_time');
      return stored ? parseInt(stored, 10) : null;
    } catch (error) {
      console.error('Failed to get last conversation end time:', error);
      return null;
    }
  },

  setLastConversationEndTime(time = Date.now()) {
    try {
      localStorage.setItem('govava_last_chat_end_time', time.toString());
    } catch (error) {
      console.error('Failed to store last conversation end time:', error);
    }
  },

  clearLastConversationEndTime() {
    try {
      localStorage.removeItem('govava_last_chat_end_time');
    } catch (error) {
      console.error('Failed to clear last conversation end time:', error);
    }
  }
}; 